/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$data = PdpRespSidebarBlurbs_viewer;
export type PdpRespSidebarBlurbs_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '9994f04976554d694381c25e6534790a';
export default node;
